// extracted by mini-css-extract-plugin
module.exports = {"link":"menu-link_link__INGcF"};